import { Controller } from "@hotwired/stimulus"

// Hoja de acciones de una fila (<dialog>): se llena con los data-* de la fila; eliminar es un form
// de Turbo (stream o 422 como toast). Doc: _docs/frontend/catalog_presentation/partner_sections.md → Cliente
export default class extends Controller {
  static targets = ["dialog", "name", "summary", "productsButton", "deleteForm", "delete", "reason"]

  connect() {
    // No cachear la hoja abierta (el snapshot se toma antes del disconnect)
    this.beforeCache = () => this.close()
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
  }

  // section-row:actions
  open(event) {
    this.row = event.detail.row
    const { sectionName, sectionSummary, sectionLayoutSummary, sectionUrl, sectionBlockedReason } = this.row.dataset
    this.nameTarget.textContent = sectionName
    this.summaryTarget.textContent = [sectionSummary, sectionLayoutSummary].filter(Boolean).join(" · ")
    this.productsButtonTarget.hidden = !this.#rowController(this.row)?.hasProductsTarget
    this.deleteFormTarget.action = sectionUrl
    this.deleteTarget.disabled = Boolean(sectionBlockedReason)
    this.reasonTarget.textContent = sectionBlockedReason || ""
    this.reasonTarget.hidden = !sectionBlockedReason
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  // Click en el ::backdrop llega al propio <dialog>
  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  reset() {
    this.row = null
  }

  rename() {
    const row = this.row
    this.close()
    this.#rowController(row)?.edit()
  }

  products() {
    const row = this.row
    this.close()
    this.#rowController(row)?.showProducts()
  }

  // "Cambiar cómo se ve": cierra y pasa la fila a la hoja de vista
  layout() {
    const row = this.row
    this.close()
    this.dispatch("layout", { detail: { row } })
  }

  // turbo:submit-end del form de eliminar: la hoja se cierra con éxito o con 422
  submitted() {
    this.close()
  }

  #rowController(row) {
    return this.application.getControllerForElementAndIdentifier(row, "section-row")
  }
}
